import Image from "next/image";
import Link from "next/link";

import LogoImg from "@/public/images/logo.png";

export default function Logo() {
  return (
    <Link className='inline-flex' href='/' aria-label='Rota Lounge'>
      <Image
        className='max-w-none'
        src={LogoImg}
        width={50}
        height={50}
        priority
        alt='Rota Lounge'
        unoptimized={true}
      />
    </Link>
  );
}
